/** Enabled when GATSBY_SENTRY_ENABLED is not false (set in .env.development / .env). */
export const isSentryEnabled = process.env.GATSBY_SENTRY_ENABLED !== 'false';

export default isSentryEnabled;
